import React from 'react';
export const ReadStatus = props => {
  const { read } = props;

  return <>{read ? <span className='livechat__dot'></span> : <span></span>}</>;
};
